module.exports = __webpack_public_path__ + "static/media/chart-swap.4460d8ce.svg";